import React, { Component } from "react";
import { DatePicker, Spin, message, Radio, Space } from "antd";
import Bridge from "../../../utils/Bridge";
import { speech_demographics_form_type } from "../../../utils/consts";
import moment from "moment";
import dayjs from "dayjs";

export default class DiagnosisForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gender:"",
      loading: false,
      email:"",
      neurostamp_id:"",
      modality_id:"",
      question_list:[],
      field_data:[],
      diagnosis_options:[],

      diagnosis:"",
      other_diagnosis:"",
      do_you_have_domentia:"",
      other_domentia:"",
      date_of_diagnosis:null,
      physician_name:"",
      hospital_name:""
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.diagnosis;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          let arr=[]
          this.setState({
            field_data: response.field_data.diagnosis,
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
          })
          let diagnosis_options=[]
          for(let item of response.field_data.diagnosis){
            if(item.field=='DIAGN'){
                diagnosis_options.push({
                  label:item.description,
                  value:item.values
                }) 
            }
          }
          for(let item of response.data){
            if(item.field=='DIAGN'){
              this.setState({
                diagnosis:item.value
              })
            }
            if(item.field=='DIAGMND'){
                this.setState({
                  other_diagnosis:item.value
                })
            }
            if(item.field=='DIAGDEM'){
                this.setState({
                    do_you_have_domentia:item.value
                })
            }
            if(item.field=='DIAGDIMO'){
                this.setState({
                    other_domentia:item.value
                })
            }
            if(item.field=='DIAGDT'){
                this.setState({
                    date_of_diagnosis:item.value ? dayjs(item.value) : null
                })
            }
            if(item.field=='NEURNAM'){
                this.setState({
                    physician_name:item.value
                })
            }
            if(item.field=='HOSPNAM'){
                this.setState({
                    hospital_name:item.value
                })
            }
          }
          this.setState({
            diagnosis_options:diagnosis_options,
            loading:false
          })
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_diagnosis: date,
    });
  };
  // step 1
  save_details = () => {
    if (!this.state.diagnosis) {
      message.warning("Please select Diagnosis value");
      return;
    }
    if (this.state.diagnosis==4) {
        if (!this.state.other_diagnosis) {
            message.warning("Please enter value of other diagnosis field");
            return;
        }
    }
    if (!this.state.do_you_have_domentia) {
        message.warning("Please select value of 'Do you have Dementia, Please specify:' field");
        return;
    }
    if (this.state.do_you_have_domentia==1) {
        if (!this.state.other_domentia) {
            message.warning("Please enter value of other dementia field");
            return;
        }
    } 
    if (!this.state.date_of_diagnosis) {
        message.warning("Please select date of diagnosis");
        return;
    }

  
    let date_of_diagnosis = dayjs(this.state.date_of_diagnosis).format("MM/DD/YYYY");
    let field_data=this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];
    let questions=[]
    for(let item of uniqueNames){
      if(item.field=='DIAGN'){
        let obj={
            value:this.state.diagnosis,
            view_name:item.view_name,
            form:"Diagnosis",
            field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='DIAGMND'){
        let obj={
            value:this.state.other_diagnosis,
            view_name:item.view_name,
            form:"Diagnosis",
            field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='DIAGDEM'){
        let obj={
            value:this.state.do_you_have_domentia,
            view_name:item.view_name,
            form:"Diagnosis",
            field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='DIAGDIMO'){
        let obj={
            value:this.state.other_domentia,
            view_name:item.view_name,
            form:"Diagnosis",
            field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='DIAGDT'){
        let obj={
            value:date_of_diagnosis,
            view_name:item.view_name,
            form:"Diagnosis",
            field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='NEURNAM'){
        let obj={
            value:this.state.physician_name,
            view_name:item.view_name,
            form:"Diagnosis",
            field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='HOSPNAM'){
        let obj={
            value:this.state.hospital_name,
            view_name:item.view_name,
            form:"Diagnosis",
            field: item.field
        }
        questions.push(obj)
      }
    }
    let params = {
      data: JSON.stringify(questions),
      step: speech_demographics_form_type.diagnosis,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
    .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                // if als
                if(this.props.is_non_als_user==false){
                  this.props.set_active_step(2);
                }else{
                  this.props.set_active_step(9);
                }
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Diagnosis</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">Diagnosis<span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) => this.setState({ diagnosis: e.target.value,other_diagnosis:"" })}
                value={this.state.diagnosis}
                direction="vertical"
              >
                <Space direction="vertical">
                    {this.state.diagnosis_options.map((item,index)=>{
                        return (
                            <Radio value={item.value} key={index}>{item.label}</Radio>
                        )
                    })}
                </Space>
              </Radio.Group>

              {this.state.diagnosis == 4 && (
                <div className="form-group">
                    <input
                        type="text"
                        name="other_diagnosis"
                        placeholder="Other Motor Neuron Disease, Please specify:"
                        value={this.state.other_diagnosis}
                        onChange={(e) => {
                            this.setState({
                                other_diagnosis: e.target.value,
                            });
                        }}
                        style={{
                            width: "100%",
                            height: 55,
                            maxWidth: 500,
                            marginTop: 20,
                        }}
                    />
                </div>
                )}
            </div>
            <div className="form-group">
              <label className="input-heading">Do you have Dementia, Please specify:<span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) => this.setState({ do_you_have_domentia: e.target.value,other_domentia:"" })}
                value={this.state.do_you_have_domentia}
                direction="vertical"
              >
                <Space>
                    <Radio value={'1'}>Yes</Radio>
                    <Radio value={'2'}>No</Radio>
                </Space>
              </Radio.Group>
              {this.state.do_you_have_domentia == 1 && (
                <div className="form-group">
                    <input
                        type="text"
                        name="other_dementia"
                        placeholder="Other Dementia, Please specify:"
                        value={this.state.other_domentia}
                        onChange={(e) => {
                            this.setState({
                                other_domentia: e.target.value,
                            });
                        }}
                        style={{
                            width: "100%",
                            height: 55,
                            maxWidth: 500,
                            marginTop: 20,
                        }}
                    />
                </div>
                )}
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Date of Diagnosis{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <DatePicker
                onChange={this.onChange}
                format={"MM/DD/YYYY"}
                value={this.state.date_of_diagnosis}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Your Neurologist's or Physician's name
              </label>
              <br />
                <input
                    type="text"
                    name="physician_name"
                    placeholder="Your Neurologist's or Physician's name"
                    value={this.state.physician_name}
                    onChange={(e) => {
                        this.setState({
                            physician_name: e.target.value,
                        });
                    }}
                    style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                    }}
                />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Clinic's or Hospital's name and city
              </label>
              <br />
                <input
                    type="text"
                    name="hospital_name"
                    placeholder="Clinic's or Hospital's name and city"
                    value={this.state.hospital_name}
                    onChange={(e) => {
                        this.setState({
                            hospital_name: e.target.value,
                        });
                    }}
                    style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                    }}
                />
            </div>
            
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                {this.props.is_non_als_user==true? (
                   <button
                   style={{
                     padding: "9px 28px 10px 21px",
                     // background: "#b3b3b3",
                     // cursor: "auto",
                   }}
                   onClick={() => {
                     this.props.set_active_step(7)
                   }}
                   className="submit-button"
                 >
                   <box-icon
                     name="chevron-left"
                     color="#fff"
                     style={{ position: "relative", top: 1 }}
                   ></box-icon>
                   Previous
                 </button>
                ):(
                  <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    background: "#b3b3b3",
                    cursor: "auto",
                  }}
                  className="submit-button"
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                )}
               
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
